import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private toastr: ToastrService,
    private utilityService: UtilityService,
  ) {}

  showSuccess(message: string, title: string = '') {
    this.toastr.success(message, title);
  }

  showError(message: string, title: string = 'Error') {
    this.toastr.error(this.utilityService.getErrorMessage(message), title);
  }

  showInfo(message: string, title = '') {
    this.toastr.info(message, title);
  }

  showWarning(message: string, title = '') {
    this.toastr.warning(message, title);
  }
}
